var React = require('react');

function YoutubeInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"24","height":"24","rx":"12","fill":"#1C3133","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18.7082 8.5301C18.5479 7.9287 18.0736 7.45443 17.4699 7.29183C16.3786 7 12.0001 7 12.0001 7C12.0001 7 7.62367 7 6.53009 7.29183C5.9287 7.45215 5.45443 7.92659 5.29183 8.5301C5 9.62139 5 11.8999 5 11.8999C5 11.8999 5 14.1783 5.29183 15.2696C5.45215 15.871 5.92659 16.3453 6.53009 16.5079C7.62367 16.7997 12.0001 16.7997 12.0001 16.7997C12.0001 16.7997 16.3786 16.7997 17.4699 16.5079C18.0713 16.3476 18.5457 15.8731 18.7082 15.2696C19 14.1783 19 11.8999 19 11.8999C19 11.8999 19 9.62139 18.7082 8.5301ZM10.6013 14.0001V9.79961L14.2383 11.8999L10.6013 14.0001Z","fill":"white","key":1})]);
}

YoutubeInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = YoutubeInline;

YoutubeInline.default = YoutubeInline;
